import React from 'react';

import Lozenge from '@atlaskit/lozenge/new/lozenge';
import { Stack } from '@atlaskit/primitives/compiled/stack';

export default (): React.JSX.Element => (
	<Stack>
		<p>
			<Lozenge appearance="success">default max width with long text which truncates</Lozenge>
		</p>
		<p>
			<Lozenge appearance="success" maxWidth={100}>
				custom max width with long text which truncates
			</Lozenge>
		</p>
	</Stack>
);
